import { render, staticRenderFns } from "./AccountGeneral.vue?vue&type=template&id=d5e74a62&"
import script from "./AccountGeneral.vue?vue&type=script&lang=js&"
export * from "./AccountGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports